module.exports = __webpack_public_path__ + "img/tango-smile.1ef100f4.svg";